export const CONTACT_TIME_ZONE_OPTION = 'Contact';
export const DATEPICKER_TIME_FORMAT = 'HHmm';
export const DATE_TIME_PARSE_FORMAT = 'YYYY-MM-DD HHmm';
export const DEFAULT_FROM_VALUE = '"~Owner.FirstName~ ~Owner.LastName~" <~Owner.Email~>';
export const DEFAULT_TOADDRESS_VALUE = '~Contact.Email~';
export const DEFAULT_TOADDRESS_LIQUID_VALUE = '[[contact.email]]';
export const DEFAULT_TEMPLATE_HTML = '<html></html>';
export const REQUEST_PAYLOAD_DATE_FORMAT = 'MM-DD-YYYY HH:mm';
export const TIME_FORMAT = 'h:mm a';
export const FILTER_LABEL = 'Filter';
export const OPEN_RATES_HELP_ARTICLE_URL = 'https://www.apple.com/newsroom/2021/06/apple-advances-its-privacy-leadership-with-ios-15-ipados-15-macos-monterey-and-watchos-8/';
export const DEFAULT_BUILDER_JSON_CONTENT_STRING = '{}';

export const AMPLITUDE_EVENT_SOURCES = {
    LEGACY_BARD: 'Legacy BARD',
    UNLAYER_BROADCAST_BUILDER: 'Unlayer Broadcast Builder',
    UNLAYER_EMAIL_FUNNEL: 'unlayerEmail',
};

export const DEFAULT_RECIPIENT_VALUES = {
    EMAIL: '~Contact.Email~',
    EMAIL2: '~Contact.EmailAddress2~',
    EMAIL3: '~Contact.EmailAddress3~',
};

export const BROADCAST_STATUS = {
    RESCHEDULING: 'RESCHEDULING',
    SCHEDULING: 'SCHEDULING',
    QUEUED: 'QUEUED',
    PROCESSING: 'PROCESSING',
    DONE: 'DONE',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR',
    DRAFT: 'DRAFT',
};

export const EMAIL_BROADCAST_SUBJECT = {
    maxlength: 232,
    autocomplete: 'nofill',
};
export const EMAIL_BROADCAST_PREVIEW = {
    maxlength: 232,
    autocomplete: 'nofill',
};

export const VALID_DISPLAY_STATUSES = {
    SEND_NOW: [BROADCAST_STATUS.PROCESSING, BROADCAST_STATUS.DONE, BROADCAST_STATUS.ERROR],
    SCHEDULE: [BROADCAST_STATUS.SCHEDULING, BROADCAST_STATUS.QUEUED, BROADCAST_STATUS.DONE, BROADCAST_STATUS.ERROR],
};

export const PENDING_STATUSES = [
    BROADCAST_STATUS.RESCHEDULING,
    BROADCAST_STATUS.SCHEDULING,
    BROADCAST_STATUS.PROCESSING,
];

export const POLLING = {
    INTERVAL: 5000,
    MAX_ATTEMPTS: 5,
    MAX_DELAY: 900000, // 15 minutes
};

export const TEST_EMAIL_MAX_RECIPIENTS = 6;

export const MESSAGE_CONSTANTS = {
    BROADCASTS: 'Broadcasts',
    EMAIL: 'Emails',
    TEXT: 'Text messages',
    EMAIL_BROADCAST: 'Email broadcast',
    SMS_BROADCAST: 'Text (SMS) broadcast',
    CREATE: 'Create broadcast',
    NEW_TYPE: 'NEW',
    ALL: 'All',
    FILTER: 'Filter',
    NO_RESULT_TEXT: 'Your search for "nosen" returned no results',
    NO_RESULT_SUBTEXT: 'Try searching for something else',
    NO_ACCESS: 'Unable to get broadcast menu options',
    EMAIL_BROADCAST_STOP_SUCCESS: 'Your broadcast has been stopped',
    EMAIL_BROADCAST_RESUME_SUCCESS: 'Your broadcast has been resumed',
    BROADCAST_DELETE_SUCCESS: 'Broadcast deleted successfully',
    BROADCAST_RESUME_SUCCESS: 'Broadcast resumed successfully',
    EMAIL_BROADCAST_ERROR_MESSAGE: 'This broadcast encountered an error',
    EMAIL_BROADCAST_SENDING_MESSAGE: 'Sending now',

    // Broadcast editor header
    SEND: 'Send',
    SCHEDULE: 'Schedule',
    SEND_BROADCAST: 'Send broadcast',
    SEND_TEST: 'Send a test',
    SCHEDULE_BROADCAST: 'Schedule broadcast',
    NO_SUBJECT: '(No subject)',

    UNLAYER_EMAIL_BUILDER_FTU_MODAL: {
        TITLE: 'New email builder',
        HEADING: 'We\'ve got a new look.',
        DESCRIPTION: 'Our email builder has been redesigned to make your experience easier and more enjoyable. We\'ve simplified the way you send an email broadcast. Now, you can easily manage all the elements of your message on one page.',
        GET_STARTED: 'Get started',
        LEARN_MORE: 'Learn more',
    },

    STATUS_CHIP: {
        Cancelled: 'Cancelled by user',
        Done: 'Sent',
        Draft: 'Draft',
        Error: 'Error',
        Processing: 'Sending',
        Queued: 'Scheduled',
        Scheduling: 'Scheduling',
    },
};

export const OPTIONS_LABELS = {
    newUnlayerEmail: 'Email broadcast',
    newEmail: 'Legacy broadcast',
    newSms: 'Text message',
};

export const NEW_BROADCAST_TYPES = ['newUnlayerEmail'];

export const BROADCAST_FILTER_VALUES = {
    SENT: 'Done',
    DRAFT: 'Draft',
    SCHEDULED: 'Queued',
};

export const BROADCAST_FILTER_LABELS = {
    ALL: 'All',
    DRAFTS: 'Draft',
    SCHEDULED: 'Scheduled',
    SENT: 'Sent',
};

export const BROADCAST_STATUS_MESSAGE = {
    RESCHEDULING: 'Rescheduling',
    SCHEDULING: 'Scheduling',
    QUEUED: 'Scheduled',
    PROCESSING: 'Sending',
    DONE: 'Sent',
    CANCELLED: 'Cancelled by user',
    ERROR: 'Error',
    DRAFT: 'Draft',
};

export const STAGE_STATUS = {
    IN_PROGRESS: 'inProgress',
    COMPLETE: 'complete',
    INVALID: 'invalid',
};

export const STATUS_TYPE = {
    DEFAULT: 'default',
    GOOD: 'good',
    WARNING: 'warning',
    ERROR: 'error',
};

const AUTOCOMPLETE_ICONS = {
    LIST: 'list',
    USER: 'user',
    TAG: 'tag',
};

export const EMAIL_EDITORS = {
    BARD: 'BardEmailBuilder',
    UNLAYER: 'UnlayerBuilder',
    DRUID: 'BardV2TemplateBuilder',
};

export const RESCHEDULABLE_EMAIL_EDITORS = [
    EMAIL_EDITORS.BARD,
    EMAIL_EDITORS.UNLAYER,
];

export const AUTOCOMPLETE_ICON_BY_CATEGORY = {
    LIST: AUTOCOMPLETE_ICONS.LIST,
    SAVEDSEARCH: AUTOCOMPLETE_ICONS.LIST,
    TAG: AUTOCOMPLETE_ICONS.TAG,
    SINGLECONTACTTAG: AUTOCOMPLETE_ICONS.USER,
    LEADSOURCE: AUTOCOMPLETE_ICONS.LIST,
    STAGE: AUTOCOMPLETE_ICONS.LIST,
    PRODUCT: AUTOCOMPLETE_ICONS.LIST,
};

export const BATCH_STATUS = {
    cancelled: 'CANCELLED',
    processing: 'PROCESSING',
    queued: 'QUEUED',
};

export const BLOCK_TYPES = {
    LOGO: 'logo',
    BUTTON: 'button',
    IMAGE: 'image',
    TEXT: 'text',
    FOOTER: 'emailFooter',
};

export const BROADCAST_SCHEDULE_OPTIONS = {
    LATER: 'later',
    NOW: 'now',
};

export const BUILDER_BLOCK_ALIGNMENTS = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
};

export const DAYS_OF_WEEK = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    NEXT_MONDAY: 8,
};

export const EMAIL_BROADCAST_BUILDERS = {
    BARD_LEGACY: 'BARD_LEGACY',
    UNIFIED_UNLAYER: 'UNIFIED_UNLAYER',
};

export const EDITOR_KINDS = {
    bardEmailBuilder: 'BardEmailBuilder',
    codeMirror: 'CodeMirror',
    unlayerEmailBuilder: 'UnlayerBuilder',
};

export const EMAIL_IMAGE_TYPES = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/gif',
];

export const UNLAYER_EMAIL_LINKS_TAG_LIMIT = 10;

export const UNLAYER_BROADCAST_TEMPLATE_COMMAND = {
    design: {},
    from: '',
    html: '',
    id: '',
    name: '',
    previewText: '',
    subject: '',
};

export const UNLAYER_BROADCAST_COMMAND = {
    emailTemplate: {
        bardJson: null,
        from: '',
        htmlBody: '',
        previewText: '',
        subject: '',
        title: '',
        editor: 'UnlayerBuilder',
        externalTemplateId: '',
    },
};

export const UNLAYER_TEMPLATE_COMMAND = {
    title: 'Untitled',
    html: DEFAULT_TEMPLATE_HTML,
    templateSource: 'UNLAYER',
    templateMedia: 'EMAIL',
    templateStatus: 'DRAFT',
    builderJson: {
        content: DEFAULT_BUILDER_JSON_CONTENT_STRING,
        options: null,
    },
};

export const REQUIRED_CAN_SPAM_FIELDS = ['companyStreetAddress1', 'companyCountry', 'companyCity', 'companyPostalCode'];

export const DKIM_LEARN_MORE_LINK_ALL_EDITIONS = 'https://help.keap.com/help/dmarc';
export const DKIM_SET_UP_LINK_NON_SPA = '/app/miscSetting/itemWrapper?systemId=nav.marketing&settingModuleName=Marketing&settingTabName=email.authentication.title';

export const CUSTOM_SENDER_DISPLAY_NAME_MAX_LENGTH = 75;
export const CUSTOM_SENDER_EMAIL_USERNAME_MAX_LENGTH = 75;

export const AGGREGATED_EMAIL_TEMPLATES_FILTER_OPTIONS = {
    ALL: 'ALL',
    BARD: 'BARD',
    UNLAYER: 'UNLAYER',
};

export const TEMPLATE_SOURCE = {
    BARD: 'BARD',
    UNLAYER: 'UNLAYER',
};

export const TEMPLATE_TYPE = {
    UNLAYER: 'UNLAYER',
    BARD_PRIVATE: 'BARD_PRIVATE',
    BARD_SENT: 'BARD_SENT',
};

export const TEMPLATE_MIGRATION_LEARN_MORE_URL = 'https://help.keap.com/help/how-to-convert-legacy-emails-into-the-new-builder';

export const BARD_TEMPLATE_MIGRATION_STATUS = {
    MANUALLY_ARCHIVED: 'ManuallyArchived',
    MIGRATED_TO_UNLAYER: 'MigratedToUnlayer',
};

export const TEMPLATE_MIGRATION_AUDIT_TYPES = {
    TAGS_MORE_THAN_TEN: 'TagsMoreThanTen',
    NO_TAGS_ALLOWED: 'NoTagsAllowed',
    BLOCK_ERROR: 'BlockError',
};
